<template lang="pug">
content-page
	div(slot="nav")
		nav
			.subtitle-1 {{$t('page.gear:feature:nav_heading')}}
			ul.list-unstyled
				li.nav-list-item(v-for="category in filteredCategories" v-if="category.products.length")
					nuxt-link(:to="localePath({name:'gear-category', params: {category: category.slug}})")
							| Alle {{category.name}}
							|
							small.grey--text ({{category.products.length}})

				template(v-for="category in filteredCategories")
					li(v-for="cluster in category.clusters")
						nuxt-link(:to="localePath({name:'gear-category-cluster', params: {category: category.slug, cluster: cluster.slug}})") {{cluster.name}}

	.hidden-sm-and-down(slot="sidebar" style="max-width: 280px;")
		ad(location="sidebar").mb-6
		snow-alarm.mb-6
		.mb-6
			a(href="/weblog/bericht/482778/aankondiging-nationale-skitest-piste-2019-2020")
				v-img(src="https://cdn.wintersport.nl/weblog/3/55229.jpg?width=640" :aspect-ratio="21/9").mb-3
				h3 {{$t('page.gear:infosheet.label.skitest')}}
			a.black--text(href="/weblog/bericht/482778/aankondiging-nationale-skitest-piste-2019-2020")
				p {{$t("page.gear:infosheet.label.reviews")}}
			.text-center
				v-btn(color="primary" outlined href="/weblog/bericht/482778/aankondiging-nationale-skitest-piste-2019-2020") {{$t('page.gear:infosheet.label.watch')}}
	.flow-left
		template(v-if="spotlightWeblog")
			h1.hidden-sm-down.mb-0 {{spotlightWeblog.title}}
			.subtitle.grey--text
				v-chip.caption.bg-ws-blue.white--text(small v-if="spotlightWeblog.editorialNote == 'ADVERTORIAL'") advertorial
				nuxt-link(:to="localePath({name:'profile-slug', params: {slug: spotlightWeblog.author.slug}})" :title="spotlightWeblog.author.username" v-if="spotlightWeblog.editorialNote != 'ADVERTORIAL'") {{spotlightWeblog.author.username}}
				|
				|
				template(v-if="!spotlightWeblog.isPublishDateHidden") {{$t('page.weblog.message:published.at.{date}', {date: $dayjs(spotlightWeblog.publishDate).format("DD MMMM YYYY")})}} ·
				template(v-if="spotlightWeblog.editDate") {{$t('page.weblog.message:edited.at.{date}', {date: $dayjs(spotlightWeblog.editDate).format("DD MMMM YYYY")})}} ·
				nuxt-link.grey--text(:to="localePath({name: 'weblog-slug', hash: '#reacties', params: { 0: spotlightWeblog.slug}})" :title="$t('page.weblog.message:link.to.reply.title')")  {{$tc('page.weblog.message:reply.{count}', spotlightWeblog.replyCount, {count: spotlightWeblog.replyCount})}}
			v-row.mb-6
				v-col(cols="12" xl="7")
					nuxt-link(:to="localePath({name: 'weblog-slug', params: { 0: spotlightWeblog.slug}})" :title="spotlightWeblog.title")
						v-img(:aspect-ratio="16/9" :src="`${spotlightWeblog.photo}?width=640`" :class="[spotlightWeblog.isVideoBlog? 'play-btn': '']")
				v-col
					p.mb-0 {{spotlightWeblog.content.introduction}}
					.text-center
						v-btn.mt-3(color="primary" outlined :to="localePath({name: 'weblog-slug', params: { 0: spotlightWeblog.slug}})" :title="spotlightWeblog.title") {{$t('page.gear:button.read.more')}}
		h2 {{$t('page.gear:label.tested')}}
		v-row.mb-6
			v-col(cols="12" md="6" lg="4" v-for="gridItem in gridItems" :key="gridItem.id")
				nuxt-link.d-flex.flex-column.grid-item__wrapper(:to="localePath(gridItem.to)" :title="gridItem.name")
					h3 {{gridItem.name}}
					div
						v-img(:src="`${gridItem.mainImage}?width=640`" :aspect-ratio="16/9")
						.gear-line-fader.hidden-xs-only.black--text
							ws-content(:value="gridItem.content")
	.flow-left
		h2 {{$t('page.gear:label.related.weblog')}}
		weblog-item(v-for="weblog in weblogItems.slice(1, 11)" :key="weblog.id" :weblog="weblog")

</template>

<style lang="sass">
.gear-line-fader, .gear-line-fader__small
	overflow: hidden
	position: relative
	&:after
		position: absolute
		content: ""
		width: 100%
		height: 2em
		z-index: 1
		top: 4em
		left: 0
		background: linear-gradient(0deg, #fff 0, hsla(0,0%,100%,0))

.grid-item__wrapper
	height: 100%
	justify-content: space-between

.gear-line-fader
	max-height: 6rem
	&:after
		top: 4em

.gear-line-fader__small
	max-height: 4rem
	&:after
		top: 2em
</style>

<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import WeblogItem from '@/components/weblog-item';

const getGearContentpage = gql`
	query getGearContentpage($limit: Int, $category: String) {
		weblogsByCategory(limit: $limit, category: $category) {
			weblogs {
				...WeblogItem
			}
		}
		clusters: gearClusters {
			id
			name
			slug
			mainImage
			content {
				...ContentDataFragment
			}
			category {
				id
				slug
			}
		}
		categories: gearCategories {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			products {
				id
			}
			clusters {
				id
				name
				slug
			}
		}
	}
	${Content.fragments}
	${WeblogItem.fragment}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/materiaal',
			'nl-BE': '/materiaal'
		}
	},
	components: {
		WeblogItem
	},
	asyncData({ app, _route }) {
		app.ads({ sidebar: { visible: true } });

		return app.$graphClient
			.query({
				query: getGearContentpage,
				variables: {
					limit: 12,
					category: 'GEAR'
				},
				errorPolicy: 'all',
				fetchPolicy: 'network-only'
			})
			.then(({ data, errors }) => {
				if (!data.weblogsByCategory) {
					return app.httpError(404, null, 'gear-01', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.meta({
					description:
						'Onze website test jaarlijkse honderden wintersportproducten die op of naast de piste kunt gebruiken. Lees onze uitgebreide reviews.',
					title: 'Wintersport producten getest',
					hasIndex: true,
					hasFollow: true
				});
				app.breadcrumbs({
					Materiaal: { name: 'gear' }
				});

				return {
					weblogItems: data.weblogsByCategory.weblogs,
					categories: data.categories,
					clusters: data.clusters
				};
			})
			.catch(error => {
				return app.httpError(500, null, 'gear-02', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		spotlightWeblog() {
			return this.weblogItems.find(weblog => {
				return !!weblog.photo;
			});
		},
		gridItems() {
			return this.shuffle([
				...this.clusters
					.filter(cluster => cluster.mainImage)
					.map(cluster => {
						return {
							...cluster,
							to: {
								name: 'gear-category-cluster',
								params: {
									category: cluster.category.slug,
									cluster: cluster.slug
								}
							}
						};
					}),
				...this.categories
					.filter(category => category.mainImage)
					.map(category => {
						return {
							...category,
							to: {
								name: 'gear-category',
								params: { category: category.slug }
							}
						};
					})
			]).slice(0, 9);
		},
		filteredCategories() {
			return this.categories.filter(category => {
				return category.slug === 'skis';
			});
		}
	},
	methods: {
		shuffle(a) {
			for (let i = a.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[a[i], a[j]] = [a[j], a[i]];
			}
			return a;
		}
	}
};
</script>
